<template>
  <div v-if="familia">
    <form class="form-horizontal" action="" autocomplete="off" @submit.stop.prevent="enviarCambios" novalidate>

    <div class="card mb-3">
      <h5 class="card-header">Datos generales</h5>
      <div class="card-body">

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="socio-titular">Socio titular</label>
          <div class="col-md-5">
            <input id="socio-titular" name="socio-titular" type="text" class="form-control" :value="titularSocio.nombre + ' ' + titularSocio.apellidos" readonly>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="observaciones">Observaciones generales</label>
          <div class="col-md-5">
            <textarea id="observaciones" name="observaciones" class="form-control" rows="3" v-model="familia.observaciones"></textarea>
          </div>
        </div>

      </div>
    </div>

    <template v-if="admin">
    <div class="card mb-3">
      <h5 class="card-header">Situación de pagos</h5>
      <div class="card-body">

        <div class="form-group row">
          <div class="col-md-2">Impago</div>
          <div class="col-md-5">
            <div class="form-check">
              <input id="impago" name="impago" type="checkbox" class="form-check-input" v-model="familia.impago">
              <label class="form-check-label" for="impago">Si está marcado la familia está en situación de impagos</label>
            </div>
          </div>

      </div>
    </div>
    </template>

    <div class="card mb-3">
      <h5 class="card-header">Domiciliación bancaria</h5>
      <div class="card-body">

        <h5 class="pb-3">Cuenta actual</h5>

        <template v-if="familia.domiciliacion">

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="dom-titular-actual">Titular cuenta</label>
          <div class="col-md-5">
            <input id="dom-titular-actual" name="dom-titular-actual" type="text" :value="titularActualDomiciliacion.nombre + ' ' + titularActualDomiciliacion.apellidos" class="form-control" readonly>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="iban-actual">IBAN</label>
          <div class="col-md-5">
            <input id="iban-actual" name="iban-actual" type="text" :value="familia.domiciliacion.iban" class="form-control" readonly>
          </div>
        </div>

        <template v-if="admin">
        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="referencia-mandato">Mandato</label>
          <div class="col-md-5">
            <input id="referencia-mandato" name="referencia-mandato" type="text" :value="familia.domiciliacion.referencia" class="form-control" readonly>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="fecha-mandato">Fecha mandato</label>
          <div class="col-md-5">
            <input id="fecha-mandato" name="fecha-mandato" type="text" :value="familia.domiciliacion.fecha_mandato" class="form-control" readonly>
          </div>
        </div>
        </template>

        <div class="form-group row">
          <div class="col-md-2">Eliminar</div>
          <div class="col-md-5">
            <div class="form-check">
              <input id="eliminar" name="dom-eliminar" type="checkbox" class="form-check-input" v-model="eliminarDomiciliacion">
              <label class="form-check-label" for="dom-eliminar">Eliminar cuenta actual sin añadir otra nueva</label>
            </div>
          </div>
        </div>
        </template>

        <template v-else>
        <span class="text-center"><i>Actualmente no existe ninguna domiciliación</i></span>
        </template>

        <hr />

        <h5 class="pt-1 pb-3">Cuenta nueva</h5>

        <p>Si el titular de la cuenta no está en la lista, deberás añadirlo primero como contacto o autorizado.</p>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="dom-titular">Titular</label>
          <div class="col-md-5">
            <select class="select form-control" id="dom-titular" name="dom-titular" :class="validarCampo(idTitularDomiciliacion != null)" v-model="idTitularDomiciliacion">
              <template v-for="p in familia.miembros">
              <option v-if="p.tipo == 'adulto'" :value="p.id" :key="p.id">{{ p.nombre }} {{ p.apellidos }}</option>
              </template>
            </select>
            <div class="invalid-feedback">Debes introducir un titular para la cuenta</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="iban">IBAN</label>
          <div class="col-md-5">
            <input id="iban" name="iban" type="text" class="form-control" :class="validarCampo(validarIBAN(iban))" v-mask="'AA## #### #### #### #### ####'" v-model="iban">
            <div class="invalid-feedback">Debes introducir un IBAN español válido</div>
          </div>
        </div>

        <template v-if="false">
        <div v-if="familia.domiciliacion" id="aviso-cambio-titular" class="d-none">
          <p><b>IMPORTANTE:</b> Al modificar el titular de la cuenta bancaria será necesario generar y firmar un nuevo mandato. Te haremos llegar en breve el documento para firmarlo.</p>
        </div>
        <div v-else>
        <p><b>NOTA:</b> Para poder domiciliar recibos en la cuenta bancaria será necesario generar y firmar una orden de domiciliación. Te haremos llegar en breve el documento, que tendrá que ser firmado por el titular de la cuenta y devuelto al AMPA.</p>
        </div>
        </template>

      </div>
    </div>

    <button type="submit" class="btn btn-primary mb-2">Guardar</button>

    </form>

  </div>

</template>

<script>

import { api } from '../api/api.js';
import { validarIBAN } from '../validacion.js';

export default {
	name: 'SociosModificarDatos',
	props: [ 'admin', 'id_familia' ],
	data () {
		return {
			validado: false,

			familia: null,
			titularSocio: null,

			titularActualDomiciliacion: null,
			eliminarDomiciliacion: false,

			idTitularDomiciliacion: null,
			iban: null,
		}
	},
	created () {
		this.obtenerFamilia();
	},
	methods: {
		validarIBAN,
		validarCampo(condicion) {
			if (! this.validado) {
				return '';
			}
			if (condicion) {
				return 'is-valid';
			} else {
				return 'is-invalid';
			}
		},
		obtenerFamilia() {
			const id_familia = this.id_familia ? this.id_familia : this.$parent.sesion.id_familia;
			api(`/familias/${id_familia}`)
				.then((data) => {
					if (data.resultado) {
						const familia = data.resultado;
						for (const m of familia.miembros) {
							if (m.rol == 'titular') {
								this.titularSocio = m;
							}
							if (familia.domiciliacion && m.id == familia.domiciliacion.titular) {
								this.titularActualDomiciliacion = m;
							}
						}
						this.familia = familia;
					} else {
						// TODO: gestionar error
					}
				})
		},
		enviarCambios() {
			if (this.iban && (! validarIBAN(this.iban) || this.idTitularDomiciliacion == null)) {
				this.validado = true;
				return;
			}

			this.validado = false;

			const data = {
				observaciones: this.familia.observaciones,
				impago: this.familia.impago,
				eliminarDomiciliacion: this.eliminarDomiciliacion,
				iban: this.iban,
				idTitularDomiciliacion: this.idTitularDomiciliacion,
			}

			api(`/familias/${this.familia.id}`, 'PUT', data)
				.then((data) => {
					if (data.resultado) {
						if (this.admin) {
							this.$router.push(`/admin/familia/${this.familia.id}`);
						} else {
							this.$router.push('/');
						}
					}
				});
		},
	}
}
</script>
